<template>
  <el-upload
    :action="action"
    :headers="uploadHeader"
    :show-file-list="true"
    :on-success="onSuccess"
    :on-error="onError"
    :on-exceed="onExceed"
    :on-remove="onRemove"
    list-type="picture-card"
    :file-list="fileList"
    accept=".jpg,.png,.jpeg"
    :multiple="true"
    :limit="limit"
    :class="size"
  >
    <i slot="default" class="el-icon-plus"></i>
  </el-upload>
</template>

<script>
import { urlPerfix } from '@/config/env'
import store from '@/store/index'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 9,
    },
    size: String,
  },
  data() {
    return {
      action: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      fileList: [],
    }
  },
  watch: {
    value(val) {
      if (val.length == 0) {
        this.fileList = val
      }
    },
  },
  created() {
    let fileList = this.value
    if (this.value.some((item) => typeof item === 'string')) {
      fileList = this.value.map((item, index) => ({
        name: 'img' + index + 1,
        url: item,
      }))
    }
    this.fileList = fileList
  },
  methods: {
    onSuccess(response, file, fileList) {
      this.onFileChange(fileList)
    },

    onFileChange(fileList) {
      let fileArray = fileList.map((item) => {
        return item.url.includes('blob') ? item.response.data : item.url
      })
      this.$emit('input', fileArray)
    },

    onError(err, file, fileList) {
      console.log(err)
    },

    onExceed(files, fileList) {
      this.$message.error(`最多只能上传${this.limit}个文件`)
    },

    onRemove(file, fileList) {
      this.onFileChange(fileList)
    },
  },
}
</script>